<template>
  <div class="wrapper hefei-bg-f5">
    <div class="container-wrap-form pay-detail">
      <div class="form-bg detail-head">
        <div class="icon-pay-success">
          <img src="../../assets/images/jidayi-hospital/icon-pay-success.png" alt />
        </div>
        <p>支付成功，请出示收银员确认</p>
      </div>
      <ul class="form-bg detail-drugstore">
        <li class="form-table">
          <div class="table-left">
            <h3 class="fc-60">药店名称</h3>
          </div>
          <div class="table-right">
            <h3 class="fc-9d">好又惠药房(软件园店)</h3>
          </div>
        </li>
        <li class="form-table">
          <div class="table-left">
            <h3 class="fc-60">订单总额</h3>
          </div>
          <div class="table-right">
            <h3 class="fc-9d">110元</h3>
          </div>
        </li>
      </ul>
      <div class="form-bg detail-payinfos">
        <ul>
          <li class="form-table yibao-total">
            <div class="table-left">
              <h3 class="fc-60">医保支付</h3>
            </div>
            <div class="table-right">
              <h3 class="fc-60">86元</h3>
            </div>
          </li>
          <li class="form-table">
            <div class="table-left">
              <h4 class="fc-60">
                <i class="icon-pay-zhanghu"></i>医保账户支付
              </h4>
            </div>
            <div class="table-right">
              <h4 class="fc-9d">86元</h4>
            </div>
          </li>
          <li class="form-table">
            <div class="table-left">
              <h4 class="fc-60">
                <i class="icon-pay-tongchou"></i>医保统筹支付
              </h4>
            </div>
            <div class="table-right">
              <h4 class="fc-9d">86元</h4>
            </div>
          </li>
        </ul>
        <ul class>
          <li class="form-table yibao-total">
            <div class="table-left">
              <h3 class="fc-60">个人自费</h3>
            </div>
            <div class="table-right">
              <h3 class="fc-196FFA">86元</h3>
            </div>
          </li>
          <li class="form-table yibao-detail">
            <div class="table-left">
              <h4 class="fc-60">
                <i class="icon-pay-way"></i>支付方式
              </h4>
            </div>
            <div class="table-right">
              <h4 class="fc-9d">微信支付</h4>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/paymentSuccess.vue